import { addCommentUserStory } from "../../../UserModule/Modules/Services/addCommentUserStory";
import Alert from "../../Alert";
import { logEntry } from "../../logEntry";
import API from "../../Network/API";
import { isLoading, isLoaded } from "../action";

//For Add MainTask
export async function createCalendargroupTask(activities,state, dispatch, getUser, MAINTASK_ADD,MAINTASK,MODULE,sprintDesc) {
  if (state.userSelected.from === 'group') {
    if (state.taskTitle.value.trim() !== "" && state.taskDescription.value.trim() !== "" && state.acceptanceCriteria.value.trim() !== "") {
      try {
        const start_time = Date.now()
        var response = await API.post("manage_userstories.php", {
          crop: state.corp,
          action: "addGroup",
          title: state.taskTitle.value,
          description: state.taskDescription.value,
          added_to: getUser.empId,
          added_by: getUser.empId,
          acceptanceCriteria: state.acceptanceCriteria.value,
          storyPoints: state.storySelected === "" ? '0' : state.storySelected,
          priorityLevel: state.prioritySelected === "" ? '0' : state.prioritySelected,
          idea_id: state.epicSelected,
          "projectId": state.projectId,
          device_id: state.device_id,
          player_id: state.player_id,
          story_type: state.userSelected.from,
          main_task_id: 0,
          group_id: state.userSelected.value,
          module_id:state.moduleId,
          target_date:state.targetDate,
          event_id:state.eventId,
          from_screen:"calendar",
          meeting_url:state.location,
          group_task_type:"Limited" 
        }, {}, false);
        const end_time = Date.now()
        if (response.status === 'True') {
          if(state.moduleId!==null){
            const message = `This ${MAINTASK} added in ${MODULE} ${(state.corp).substring(0, 3).toUpperCase()} - ${sprintDesc} from calendar`
            await addCommentUserStory(dispatch,getUser,response.story_id,message,"11");
          }
          getUserIdWithEmails(state.userSelected.members_email, state, dispatch, getUser, response.us_id,MAINTASK,MODULE,sprintDesc)
          activities && logEntry({
            user_id: getUser.userName, logging_level: 3,
            activity_id: activities["Calendar"], sub_activity: "Create Group Task",response_time:(end_time-start_time),
            task_meta_data : {story_id:response.story_id}
          },getUser)
        }
      } catch (error) {
        Alert('error', error.message);
        dispatch(isLoaded());
        activities && logEntry({
          user_id: getUser.userName, logging_level: 2,
          activity_id: activities["Calendar"], sub_activity: "Create Group Task",error_message:error.message,
        },getUser)
      }
    }
  } else {
    dispatch(isLoading());
    if (state.taskTitle.value.trim() !== "" && state.taskDescription.value.trim() !== "" && state.acceptanceCriteria.value.trim() !== "") {
      try {
        // eslint-disable-next-line
        var response = await API.post("manage_userstories.php", {
          crop: state.corp,
          action: "add",
          title: state.taskTitle.value,
          description: state.taskDescription.value,
          added_to: state.userSelected.value,
          added_by: getUser.empId,
          acceptanceCriteria: state.acceptanceCriteria.value,
          storyPoints: state.storySelected === "" ? '0' : state.storySelected,
          priorityLevel: state.prioritySelected === "" ? '0' : state.prioritySelected,
          idea_id: state.epicSelected,
          "projectId": state.projectId,
          device_id: state.device_id,
          player_id: state.player_id,
          story_type: state.userSelected.from,
          main_task_id: 0,
          module_id:state.moduleId,
          target_date:state.targetDate,
          event_id:state.eventId,
          from_screen:"calendar",
          meeting_url:state.location, 

        }, {}, false);
        if (response.status === 'True') {
          Alert("success", MAINTASK_ADD);
        }
      } catch (error) {
        Alert('error', error.message);
        dispatch(isLoaded());
      }
    }

    else {
      Alert("warning", "Please enter required fields ")
      dispatch(isLoaded());
    }
  }

}

export async function createGroupTaskFromTemplate(state, dispatch, getUser, storyTitle, MAINTASK_ADD) {
  if (storyTitle !== state.taskTitle.value) {
    if (state.userSelected.from === 'group') {
      if (state.taskTitle.value.trim() !== "" && state.taskDescription.value.trim() !== "" && state.acceptanceCriteria.value.trim() !== "") {
        try {
          var response = await API.post("manage_userstories.php", {
            crop: state.corp,
            action: "add",
            title: state.taskTitle.value,
            description: state.taskDescription.value,
            added_to: getUser.empId,
            added_by: getUser.empId,
            acceptanceCriteria: state.acceptanceCriteria.value,
            storyPoints: state.storySelected === "" ? '0' : state.storySelected,
            priorityLevel: state.prioritySelected === "" ? '0' : state.prioritySelected,
            idea_id: state.epicSelected,
            "projectId": state.projectId,
            device_id: state.device_id,
            player_id: state.player_id,
            story_type: state.userSelected.from,
            main_task_id: 0,
            group_id: state.userSelected.value,
            module_id:state.moduleId,
            target_date:state.targetDate,
            event_id:state.eventId,
            from_screen:"calendar",
            meeting_url:state.location, 
          }, {}, false);
          if (response.status === 'True') {
            Alert("success", MAINTASK_ADD);
            getUserIdWithEmails(state.userSelected.members_email, state, dispatch, getUser, response.us_id)
          }
        } catch (error) {
          Alert('error', error.message);
          dispatch(isLoaded());
        }
      }
    } else {
      dispatch(isLoading());
      if (state.taskTitle.value.trim() !== "" && state.taskDescription.value.trim() !== "" && state.acceptanceCriteria.value.trim() !== "") {
        try {
          // eslint-disable-next-line
          var response = await API.post("manage_userstories.php", {
            crop: state.corp,
            action: "add",
            title: state.taskTitle.value,
            description: state.taskDescription.value,
            added_to: state.userSelected.value,
            added_by: getUser.empId,
            acceptanceCriteria: state.acceptanceCriteria.value,
            storyPoints: state.storySelected === "" ? '0' : state.storySelected,
            priorityLevel: state.prioritySelected === "" ? '0' : state.prioritySelected,
            idea_id: state.epicSelected,
            "projectId": state.projectId,
            device_id: state.device_id,
            player_id: state.player_id,
            story_type: state.userSelected.from,
            main_task_id: 0,
            module_id:state.moduleId,
            target_date:state.targetDate,
            event_id:state.eventId,
            from_screen:"calendar",
            meeting_url:state.location, 

          }, {}, false);
          if (response.status === 'True') {
            Alert("success", MAINTASK_ADD);
          }
        } catch (error) {
          Alert('error', error.message);
          dispatch(isLoaded());
        }

      }

      else {
        Alert("warning", "Please enter required fields ")
        dispatch(isLoaded());
      }
    }
  } else {
    Alert("warning", "Please change user story title ")
    dispatch(isLoaded());
  }

}

const getUserIdWithEmails = async (members_email, state, dispatch, getUser, us_id,MAINTASK,MODULE,sprintDesc) => {
  const emails = members_email.match(/[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}/g);
  // Remove duplicates by converting the array to a Set
  const uniqueEmailsSet = new Set(emails);
  // Convert Set back to array if needed
  const uniqueEmailsArray = [...uniqueEmailsSet];
  const filteredEmails = uniqueEmailsArray.filter(email => email !== getUser.userName);
  try {
    var response = await API.post("get_user.php", {
      action: "get_user_by_email",
      emailArray: filteredEmails,
      "projectId": state.projectId
    }, {}, false);
    if (response.status === 'True') {
      response.data.map(item => {
        return createGroupMainTask(state, dispatch, getUser, item.empid, parseInt(us_id),MAINTASK,MODULE,sprintDesc)
      })
    }
  } catch (error) {
    console.log(error)
  }
}

export async function createGroupMainTask(state, dispatch, getUser, empId, us_id,MAINTASK,MODULE,sprintDesc) {
  dispatch(isLoading());
  if (state.taskTitle.value.trim() !== "" && state.taskDescription.value.trim() !== "" && state.acceptanceCriteria.value.trim() !== "") {
    try {
      var response = await API.post("manage_userstories.php", {
        crop: state.corp,
        action: "add",
        title: state.taskTitle.value,
        description: state.taskDescription.value,
        added_to: empId,
        added_by: getUser.empId,
        acceptanceCriteria: state.acceptanceCriteria.value,
        storyPoints: state.storySelected === "" ? '0' : state.storySelected,
        priorityLevel: state.prioritySelected === "" ? '0' : state.prioritySelected,
        idea_id: state.epicSelected,
        "projectId": state.projectId,
        device_id: state.device_id,
        player_id: state.player_id,
        story_type: 'group',
        main_task_id: us_id,
        module_id:state.moduleId,
        target_date:state.targetDate,
        event_id:state.eventId,
        from_screen:"calendar",
        meeting_url:state.location,
        group_task_type:"Limited" 

      }, {}, false);
      if (response.status === 'True') {
        dispatch(isLoaded());
        console.log("Success")
        if(state.moduleId!==null){
          const message = `This ${MAINTASK} added in ${MODULE} ${(state.corp).substring(0, 3).toUpperCase()} - ${sprintDesc} from calendar`
          await addCommentUserStory(dispatch,getUser,response.story_id,message,"11");
        }
        dispatch(isLoaded());
      }
    } catch (error) {
      console.log("error")
      dispatch(isLoaded());
    }
  }

  else {
    console.log("error")
    dispatch(isLoaded());
  }
}